export const isPendingStyleSample = (sample) => sample?.status === 'pending' || sample?.status === 'uploaded';

export const deriveLatestPendingBatch = (samples = []) => {
  const eligible = samples.filter(isPendingStyleSample).filter((sample) => sample?.metadata?.upload_batch_id);
  if (eligible.length === 0) {
    return { batchId: null, sampleIds: [] };
  }

  const newest = [...eligible].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))[0];
  const batchId = newest.metadata.upload_batch_id;
  const sampleIds = eligible
    .filter((sample) => sample?.metadata?.upload_batch_id === batchId)
    .map((sample) => sample.id)
    .filter(Boolean);

  return { batchId, sampleIds };
};

export const resolveCompileTargets = ({
  samples = [],
  currentUploadBatchId = null,
  currentUploadSampleIds = [],
}) => {
  const eligible = samples.filter(isPendingStyleSample);

  if (currentUploadSampleIds.length > 0) {
    const sampleIds = eligible.filter((sample) => currentUploadSampleIds.includes(sample.id)).map((sample) => sample.id);
    return {
      sampleIds,
      uploadBatchId: currentUploadBatchId,
      hasTargets: sampleIds.length > 0,
      source: 'current-upload-sample-ids',
    };
  }

  if (currentUploadBatchId) {
    const sampleIds = eligible
      .filter((sample) => sample?.metadata?.upload_batch_id === currentUploadBatchId)
      .map((sample) => sample.id);
    return {
      sampleIds,
      uploadBatchId: currentUploadBatchId,
      hasTargets: sampleIds.length > 0,
      source: 'current-upload-batch-id',
    };
  }

  const latestBatch = deriveLatestPendingBatch(samples);
  return {
    sampleIds: latestBatch.sampleIds,
    uploadBatchId: latestBatch.batchId,
    hasTargets: latestBatch.sampleIds.length > 0,
    source: latestBatch.batchId ? 'latest-pending-batch' : 'none',
  };
};